import { useEffect, useRef } from "react";
import {
  Backdrop,
  Box,
  Fade,
  IconButton,
  makeStyles,
  Modal,
  Typography,
} from "@material-ui/core";
import CloseIcon from "@mui/icons-material/Close";
import DownloadIcon from "@mui/icons-material/Download";
import componentStylesCardDeck from "assets/theme/components/cards/card-deck";
import componentStyles from "assets/theme/views/admin/dashboard";
import ToolkitTable from "components/Cards/Tables/ToolkitTable";
import { columnTextField } from "utils/tables-utils";
import { IsMobile } from "utils/is-mobile";

const useStyles = makeStyles(componentStyles);
const useStylesCardDeck = makeStyles(componentStylesCardDeck);
const useMyStyles = makeStyles(() => ({
  th: {
    color: "#32325d",
    fontSize: ".75rem",
    fontFamily: "inherit",
    fontWeight: 600,
    lineHeight: 1.5,
    marginBottom: ".5rem",
    textAlign: "center",
    paddingBottom: "15px",
  },
  td: {
    fontSize: ".75rem",
    fontFamily: "inherit",
    fontWeight: 500,
    textAlign: "center",
    padding: "10px 0px",
    whiteSpace: "normal",
    wordBreak: "break-word",
  },
}));

export default function ModalHistoryExport({
  open,
  handleClose,
  data,
  handleGetZipLink,
}) {
  const isMobile = IsMobile();
  const classes = {
    ...useStyles(),
    ...useStylesCardDeck(),
    ...useMyStyles(),
  };

  const timerRef = useRef(null);

  useEffect(() => {
    const hasPending = () => {
      if (!data || !Array.isArray(data)) return false;
      return data.some((item) => item.Status != "FINALIZADO");
    };

    if (open && hasPending()) {
      timerRef.current = setInterval(() => {
        if (hasPending()) {
          handleGetZipLink && handleGetZipLink();
        }
      }, 10000);
    }

    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
      }
    };
  }, [open, data, handleGetZipLink]);

  const columnModel = [
    columnTextField(
      {
        dataField: "DataDownload",
        text: "Data do download",
        align: "center",
      },
      false
    ),
    columnTextField(
      {
        dataField: "UrlZipDownload",
        text: "URL do ZIP",
        headerAlign: "center",
        formatter: (cell, row) => {
          if (!row.UrlZipDownload) return;
          const start = row?.UrlZipDownload?.slice(0, 18);
          const end = row?.UrlZipDownload?.slice(-40);
          const displayUrl = `${start}...${end}`;
          return displayUrl;
        },
      },
      false
    ),
    columnTextField(
      {
        dataField: "Status",
        text: "Status",
        align: "center",
        formatter: (cell, row) => (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Typography variant="body2">{row.Status}</Typography>
          </div>
        ),
      },
      false
    ),
    columnTextField(
      {
        dataField: "Download",
        text: "Download",
        align: "center",
        formatter: (cell, row) => (
          <div style={{ display: "flex", justifyContent: "center" }}>
            {row.Status == "FINALIZADO" && (
              <IconButton
                onClick={() => {
                  const link = document.createElement("a");
                  link.href = row.UrlZipDownload;
                  link.download = "imagens.zip";
                  document.body.appendChild(link);
                  link.click();
                }}
              >
                <DownloadIcon />
              </IconButton>
            )}
          </div>
        ),
      },
      false
    ),
  ];

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={open}
      onClose={() => handleClose()}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
      style={{
        display: "flex",
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Fade in={open}>
        <div
          className={classes.paper}
          style={{
            backgroundColor: "#FFF",
            padding: "20px",
            width: isMobile ? "90%" : "70%",
            maxHeight: "90vh",
            borderRadius: 8,
          }}
        >
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: isMobile ? 0 : "1rem",
              cursor: "pointer",
              justifyContent: "flex-end",
            }}
            onClick={() => handleClose()}
          >
            <Typography variant="caption">Fechar</Typography>
            <CloseIcon
              onClick={() => handleClose()}
              style={{ marginLeft: "0.5rem" }}
            />
          </Box>

          <ToolkitTable
            dataTable={data?.slice(0, 6)}
            searched={Boolean(data)}
            keyField="UrlZipDownload"
            notFoundTitle="Não foi encontrado links de downloads disponíveis."
            columnModel={columnModel}
            headerTitle="Histórico de Downloads"
            style={{
              maxHeight: "70vh",
              overflowY: "auto",
            }}
          />
        </div>
      </Fade>
    </Modal>
  );
}
